var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex items-center gap-1 px-4 py-2 text-base font-semibold text-white no-underline transition-all duration-100 whitespace-nowrap hover:text-brand-primary",attrs:{"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }